// helper/currencyHelper.ts

export const getCurrencySymbol = (currencyCode?: string | null): string => {
  if (!currencyCode) {
    return "₼";
  }

  const normalizedCode = currencyCode.trim().toUpperCase();

  if (normalizedCode === "AZN") {
    return "₼";
  }

  if (normalizedCode === "CNY" || normalizedCode === "RMB") {
    return "¥";
  }

  if (normalizedCode === "USD") {
    return "$";
  }

  if (normalizedCode === "EUR") {
    return "€";
  }

  if (normalizedCode === "TRY") {
    return "₺";
  }

  if (normalizedCode === "RUB") {
    return "₽";
  }

  return normalizedCode;
};

export const parsePrice = (value: unknown): number => {
  if (typeof value === "number") return value;
  if (typeof value === "string") {
    const n = parseFloat(value.replace(/,/g, ""));
    return Number.isNaN(n) ? 0 : n;
  }
  return 0;
};
